import {Box, styled} from '@mui/material';

const InputFieldContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  paddingBottom: '24px',
}));

export default InputFieldContainer;
